var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'pc-ui-fixed-text': _vm.isPcUi },attrs:{"id":"app"}},[_c('router-view'),(_vm.isPcUi)?_c('ChatWorkbenchHost'):_c('MobileChatSheet'),_c('WorkflowChatEntry'),(_vm.showMobileLocaleDock)?_c('MobileLocaleDock'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }